
import React from 'react';
import { Icon, Text } from '../../../ui-kit';
import '../styles/_requested-video-extras-view-list.scss';







function VideoExtrasList({
  listExtras: stockAssets,
  hasShutterStockAccess,
  isInvoice = false
}) {
  const getSourceText = (source) => {
    if (source === 'shutterstock') {
      return isInvoice ? 'stock unlimited' : 'asset';
    }
    return source;
  };

  return (
    stockAssets.length ?
    <ul className="requested-video-extras-view-list">
        {stockAssets.map(({ source, assetId, cost }) =>
      <li key={assetId} className="requested-video-extras-view-list__item">
            <div className="requested-video-extras-view-list__item__info">
              <Icon className="requested-video-extras-view-list__item__info--name-icon" name="youtubedef" size={20} />
              <Text className="requested-video-extras-view-list__item__info--title">
                {getSourceText(source)}
              </Text>
            </div>
            <div className="requested-video-extras-view-list__item__info--description">
              <Text ellipsisOverflow>{assetId}</Text>
            </div>
            <div className="requested-video-extras-view-list__item__info">
              <Text>{hasShutterStockAccess ? cost.replace(/[0-9].+/g, '0') : cost}</Text>
            </div>
          </li>
      )}
      </ul> :
    null);

}

export default VideoExtrasList;